import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'app-comparision-stats',
  templateUrl: './comparision-stats.component.html',
  styleUrls: ['./comparision-stats.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComparisionStatsComponent implements OnInit {
  @Input() operation: any = 0;
  @Input() amount = 0;
  @Input() percentageSymbol: boolean = false;
  constructor() {}

  ngOnInit() {}

  returnSign(num) {
    return Math.sign(num);
  }

  returnPositive(num) {
    return Math.abs(num);
  }
}
